import * as classroomApi from "./classroomApi";

export const invalidateTokenOnServer = async (): Promise<object> => {
	const endpoint = `v1/logout`;

	return await classroomApi.Put2(endpoint, undefined);
};
